export default __webpack_public_path__ + "a0865be.png";